export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
